module.exports = __webpack_public_path__ + "static/media/Expansions_card_bg_03.62cb2c72.jpg";